import { createSelector } from 'reselect'

export const getUnsavedValue = (state, props) => {
  if (!props.saveChanges) return null

  const unsavedValue = state.kanbo.unsavedChanges[props.saveChanges]

  if (!unsavedValue) return null

  return unsavedValue
}

export default () => createSelector(
  [getUnsavedValue],
  (unsavedValue) => {
    return {
      unsavedValue
    }
  }
)
